import {
  CORE_HOTELS_CFAR_NAME,
  CoreHotelsCfarExerciseComponents,
} from "@b2bportal/core-types";

import { CORE_HOTELS_CFAR_STYLE_OVERRIDES } from "../../hotels-cfar/styles";
import HtsLodgingCfarNonExercisableContentStyles from "./HtsLodgingCfarNonExercisableContent.module.scss";
import LodgingCfarExerciseErrorExercisedStyles from "./LodgingCfarExerciseErrorExercised.module.scss";
import LodgingCfarExerciseGenericActionViewStyles from "./LodgingCfarExerciseGenericActionView.module.scss";

export const CORE_HOTELS_CFAR_EXERCISE_STYLE_OVERRIDES = {
  [CORE_HOTELS_CFAR_NAME]: {
    ...CORE_HOTELS_CFAR_STYLE_OVERRIDES[CORE_HOTELS_CFAR_NAME],
    [CoreHotelsCfarExerciseComponents.HtsLodgingCfarNonExercisableContent]:
      HtsLodgingCfarNonExercisableContentStyles,
    [CoreHotelsCfarExerciseComponents.LodgingCfarExerciseErrorExercised]:
      LodgingCfarExerciseErrorExercisedStyles,
    [CoreHotelsCfarExerciseComponents.LodgingCfarExerciseGenericActionView]:
      LodgingCfarExerciseGenericActionViewStyles,
  },
};
